import React from "react";
import Modal from "react-bootstrap/Modal";

export default function ViewInfoModal({ data, visible, setOnView }) {
  return (
    <Modal size="lg" show={visible} centered>
      <div className="centerAlign">
        <table className="view">
          <thead>
            <tr>
              <th>項目</th>
              <th>數值</th>
              <th>項目</th>
              <th>數值</th>
              <th>項目</th>
              <th>數值</th>
            </tr>
          </thead>
          <tbody>
            <tr>
              <td>節點編號</td>
              <td>{`${data["id"]}`}</td>
              <td>總虛功率</td>
              <td>{`${data["Q_total"]}`}</td>
              <td>C相實功方向</td>
              <td>{`${data["P_C_dir"]}`}</td>
            </tr>
            <tr>
              <td>A相電壓</td>
              <td>{`${data["V_A"]}`}</td>
              <td>A相虛功率</td>
              <td>{`${data["Q_A"]}`}</td>
              <td>正向實功總電量</td>
              <td>{`${data["Ph_pos"]}`}</td>
            </tr>
            <tr>
              <td>B相電壓</td>
              <td>{`${data["V_B"]}`}</td>
              <td>B相虛功率</td>
              <td>{`${data["Q_B"]}`}</td>
              <td>負向實功總電量</td>
              <td>{`${data["Ph_neg"]}`}</td>
            </tr>
            <tr>
              <td>C相電壓</td>
              <td>{`${data["V_C"]}`}</td>
              <td>C相虛功率</td>
              <td>{`${data["Q_C"]}`}</td>
              <td>總虛功總電量</td>
              <td>{`${data["Qh_total"]}`}</td>
            </tr>
            <tr>
              <td>A相電流</td>
              <td>{`${data["I_A"]}`}</td>
              <td>總虛功方向</td>
              <td>{`${data["Q_total_dir"]}`}</td>
              <td>虛功總電量方向I</td>
              <td>{`${data["Qh_1"]}`}</td>
            </tr>
            <tr>
              <td>B相電流</td>
              <td>{`${data["I_B"]}`}</td>
              <td>A相虛功方向</td>
              <td>{`${data["Q_A_dir"]}`}</td>
              <td>虛功總電量方向II</td>
              <td>{`${data["Qh_2"]}`}</td>
            </tr>
            <tr>
              <td>C相電流</td>
              <td>{`${data["I_C"]}`}</td>
              <td>B相虛功方向</td>
              <td>{`${data["Q_B_dir"]}`}</td>
              <td>虛功總電量方向III</td>
              <td>{`${data["Qh_3"]}`}</td>
            </tr>
            <tr>
              <td>總實功率</td>
              <td>{`${data["P_total"]}`}</td>
              <td>C相虛功方向</td>
              <td>{`${data["Q_C_dir"]}`}</td>
              <td>虛功總電量方向IV</td>
              <td>{`${data["Qh_4"]}`}</td>
            </tr>
            <tr>
              <td>A相實功率</td>
              <td>{`${data["P_A"]}`}</td>
              <td>總實功方向</td>
              <td>{`${data["P_total_dir"]}`}</td>
              <td>漏電流</td>
              <td>{`${data["I_leak"]}`}</td>
            </tr>
            <tr>
              <td>B相實功率</td>
              <td>{`${data["P_B"]}`}</td>
              <td>A相實功方向</td>
              <td>{`${data["P_A_dir"]}`}</td>
              <td>當前溫度</td>
              <td>{`${data["temp"]}`}</td>
            </tr>
            <tr>
              <td>C相實功率</td>
              <td>{`${data["P_C"]}`}</td>
              <td>B相實功方向</td>
              <td>{`${data["P_B_dir"]}`}</td>
              <td>紀錄時間</td>
              <td>{`${data["time"]}`}</td>
            </tr>
          </tbody>
        </table>
        <div className="control_form">
          <button onClick={() => setOnView(false)} type="button">
            關閉
          </button>
        </div>
      </div>
    </Modal>
  );
}
